import { DataAction, Payload, StateRepository } from '@angular-ru/ngxs/decorators';
import { NgxsDataRepository } from '@angular-ru/ngxs/repositories';
import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Selector, State, Store } from '@ngxs/store';
import { produce } from 'immer';
import { BehaviorSubject } from 'rxjs';
import { filter, first, map, mergeMap } from 'rxjs/operators';
import { LazyLoadedWidgets } from 'src/app/app-routing-lazy';
import { Member } from 'src/app/models/member';
import { ILazyComponentHandler } from 'src/app/models/smart-actions.models';
import { MemberService } from 'src/app/services/member/member.service';
import { Utilities } from 'src/app/services/utilities';

import { RightPanelStateModel } from './rightpanel.models';

@StateRepository()
@State<RightPanelStateModel>({
    name: 'rightPanelState',
    defaults: {

    }
})
@Injectable()
export class RightPanelService extends NgxsDataRepository<RightPanelStateModel> implements ILazyComponentHandler {

    currentCustomViewMetadata?: any;

    private navigationForMemberDashboard$ = new BehaviorSubject<boolean>(false);
    lastMemberBase64: any;

    @Selector()
    static customView(state: RightPanelStateModel) {
        return state.currentCustomView;
    }

    @Selector()
    static openPanel(state: RightPanelStateModel) {
        return state.openPanel;
    }


    get customViewSync(): string {
        return this.store.selectSnapshot<string>(RightPanelService.customView);
    }

    get openPanelSync() {
        return this.store.selectSnapshot<boolean>(RightPanelService.openPanel);
    }

    get openPanel$() {
        return this.store.select<boolean>(RightPanelService.openPanel);
    }


    constructor(
        private store: Store,
        private route: ActivatedRoute,
        private router: Router
    ) {
        super();
        this.defaultRightPanel();

    }


    defaultRightPanel() {
        this.router.events.pipe(filter(event => event instanceof NavigationEnd), map(event => {
                const route = Utilities.routeLastChild(this.route);
                return !!route && !!route.routeConfig && !!route.routeConfig.component && route.routeConfig.component.name.toUpperCase() === 'MEMBERDASHBOARDCOMPONENT';
        })).subscribe(navigation => {
            this.navigationForMemberDashboard$.next(navigation);
        });

        this.store.select<Member>(MemberService.member).pipe(filter(_ => !!_), filter(member => member.base64 !== this.lastMemberBase64), mergeMap(member => {
            return this.navigationForMemberDashboard$.asObservable().pipe(map(dashboardNavigation => ({ dashboardNavigation, member })), first())
        }))
        .subscribe(({ dashboardNavigation, member }) => {
            if (member && member.relations && member.relations.length > 0 && dashboardNavigation) {
                this.setCurrentCustomView(LazyLoadedWidgets.COMPONENT_RIGHTPANEL_RELATIONS);
                this.lastMemberBase64 = member.base64;
            }
        });



        // this.store.select<Member>(MemberService.member).pipe(filter(_ => !!_)).subscribe(member => {
        //     if (member && member.relations && member.relations.length > 0 && this.route.routeConfig.path === 'dashboard') {
        //         this.setCurrentCustomView(LazyLoadedWidgets.COMPONENT_RIGHTPANEL_RELATIONS);
        //     }
        // });
    }

    @DataAction()
    setCurrentCustomView(@Payload('viewId') viewId: string, @Payload('metadata') metadata?: any) {
        this.currentCustomViewMetadata = metadata;

        this.ctx.setState(produce(this.ctx.getState(), (draft: RightPanelStateModel) => {
            draft.currentCustomView = viewId;
        }));

        return viewId;
    }

    @DataAction()
    setOpenPanel(@Payload('value') value: boolean) {
        this.ctx.setState(produce(this.ctx.getState(), (draft: RightPanelStateModel) => {
            draft.openPanel = value;
        }));
    }

    @DataAction()
    toggleOpenPanel() {
        const openPanel = this.snapshot.openPanel;
        this.ctx.setState(produce(this.ctx.getState(), (draft: RightPanelStateModel) => {
            draft.openPanel = !openPanel;
        }));
    }

}
